import { getImageData } from '@/components/Modals/ConfirmDownload/utils/getImageData';
import { assetGroupIsLut } from '@/features/Downloads/Gateway/internal/assetGroupIsLut';

import type { DownloadAssetKind, DownloadStageAsset } from './atom';
import type { AssetGroup } from '@/types/asset';

// `AssetGroup.type` (`music | sfx | motion | stock_footage`) maps to the
// download stage's asset kind. Motion covers both Motion Graphics and LUTs,
// which the gateway's canonical predicate separates.
export const toAssetKind = (asset: AssetGroup): DownloadAssetKind => {
  if (asset.type === 'music' || asset.type === 'sfx') {
    return asset.type;
  }
  if (asset.type === 'motion') {
    return assetGroupIsLut({ asset }) ? 'lut' : 'mg';
  }
  return 'stock-video';
};

// `is_premium` is present on every `AssetGroup.data` variant; the cast just
// avoids narrowing on the discriminated union for a single shared field.
export const isPremiumAsset = (asset: AssetGroup): boolean =>
  Boolean((asset.data as { is_premium?: boolean }).is_premium);

// Maps a full `AssetGroup` down to the display-level payload the download
// scenes' summary tile renders.
export const toDownloadStageAsset = (asset: AssetGroup): DownloadStageAsset => {
  const { imgSrc, imgAlt, assetName, artistName } = getImageData(asset);
  return { kind: toAssetKind(asset), imgSrc, imgAlt, assetName, artistName };
};
